import React, { Component } from 'react';
import {Button, ButtonGroup, ButtonToolbar} from 'react-bootstrap';

export class ContactList extends Component {

  render() {
    return (
      <div>

      <div className="col-lg-12">
      <ButtonToolbar>
        <ButtonGroup bsSize="xsmall">
          <Button>A</Button>
          <Button>B</Button>
          <Button>C</Button>
          <Button>D</Button>
          <Button>E</Button>
          <Button>F</Button>
          <Button>G</Button>
          <Button>H</Button>
          <Button>I</Button>
        </ButtonGroup>
      </ButtonToolbar>
      <hr />
      </div>
      <div className="col-lg-12">
          <div className="contact-box">
              <div className="col-sm-2">
                  <div className="text-center">
                      <img width="50" alt="image" className="img-circle m-t-xs img-responsive" src="/img/a3.jpg" />
                  </div>
              </div>

              <div className="col-sm-8">
                  <div className="m-t-xs font-bold"> <strong>Monica Smith</strong> - Marketing manager</div>
                  <p><i className="fa fa-map-marker"></i> Riviera State 32/106 - Washington DC - USA</p>
              </div>
              <div className="col-sm-2">
                <button className="btn btn-circle btn-xs pull-right" type="button" onClick={this.openAddressBook}><i className="fa fa-id-card"></i></button>
              </div>
              <div className="clearfix"></div>
          </div>
      </div>

      <div className="col-lg-12">
          <div className="contact-box">
              <div className="col-sm-2">
                  <div className="text-center">
                      <img width="50" alt="image" className="img-circle m-t-xs img-responsive" src="/img/a2.jpg" />
                  </div>
              </div>

              <div className="col-sm-8">
                  <div className="m-t-xs font-bold"> <strong>Monica Smith</strong> - Marketing manager</div>
                  <p><i className="fa fa-map-marker"></i> Riviera State 32/106 - Washington DC - USA</p>
              </div>

              <div className="col-sm-2">
                <button className="btn btn-circle btn-xs pull-right" type="button" onClick={this.openAddressBook}><i className="fa fa-id-card"></i></button>
              </div>

              <div className="clearfix"></div>
          </div>
      </div>

      <div className="col-lg-12">
          <div className="contact-box">
              <div className="col-sm-2">
                  <div className="text-center">
                      <img width="50" alt="image" className="img-circle m-t-xs img-responsive" src="/img/a4.jpg" />
                  </div>
              </div>

              <div className="col-sm-8">
                  <div className="m-t-xs font-bold"> <strong>Monica Smith</strong> - Marketing manager</div>
                  <p><i className="fa fa-map-marker"></i> Riviera State 32/106 - Washington DC - USA</p>
              </div>

              <div className="col-sm-2">
                <button className="btn btn-circle btn-xs pull-right" type="button" onClick={this.openAddressBook}><i className="fa fa-id-card"></i></button>
              </div>

              <div className="clearfix"></div>
          </div>
      </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactList.js